import { Translate } from '@chipinside/translate'

export const buildImportTypeField = () => ({
  label: Translate({ messageKey: 'data_to_be_processed' }),
  name: 'import_type',
  options: [
    {
      label: Translate({ messageKey: 'all_male' }),
      value: 'all',
    },
    {
      label: Translate({ messageKey: 'herd_and_reproduction' }),
      value: 'reproduction',
    },
    {
      label: Translate({ messageKey: 'herd_and_reproduction_and_batches' }),
      value: 'reproduction_and_batches',
    },
    {
      label: Translate({ messageKey: 'herd_and_reproduction_and_milk_control' }),
      value: 'reproduction_and_milkings',
    },
    {
      label: Translate({ messageKey: 'milk_control_and_batches' }),
      value: 'milkings_and_batches',
    },
    {
      label: Translate({ messageKey: 'milk_control' }),
      value: 'milkings',
    },
    {
      label: Translate({ messageKey: 'batch_plural' }),
      value: 'batches',
    },
  ],
  rules: {
    required: {
      message: Translate({
        messageKey: ['required_field', 'data_to_be_processed'],
        separator: ' - ',
      }),
      value: true,
    },
  },
  type: 'select',
  value: 'all',
})
